/**
 * Mirrors the rules MachineConfigurationService enforces. The server still has the final say - this
 * only keeps the field from accepting something it would reject.
 */
export const MACHINE_CODE_MAX_LENGTH = 5;
export const MACHINE_NAME_MAX_LENGTH = 50;

export const MACHINE_CODE_HINT = `Up to ${MACHINE_CODE_MAX_LENGTH} characters, A-Z and 0-9`;

/**
 * Applied on every keystroke: drops anything that is not A-Z or 0-9, upper cases what is left and
 * trims to the maximum length. Typing "bp-4" leaves "BP4" in the field.
 *
 * Upper casing happens here as well as on the server so the field shows the value that will be
 * stored, rather than silently changing it on save.
 */
export const sanitizeMachineCode = (value: string): string =>
  (value ?? "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, MACHINE_CODE_MAX_LENGTH);

/** Returns the message to show under the field, or null when the code is acceptable. */
export const validateMachineCode = (value: string): string | null => {
  if (value.length === 0) {
    return "A machine code is required.";
  }

  return null;
};
